import{styled as r,Divider as a}from"@mui/material";var i=r(a)((function(r){return{margin:"10px 0"}}));export{i as default};
//# sourceMappingURL=index.js.map
